import ReactStrapTable from 'components/reactStrapTable';
import React, { useEffect, useState } from 'react'
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import ConfigIcon from "assets/icon/config-setting-icon.svg";
import ConfigIconHover from "assets/icon/config-setting-icon-hover.svg";
import EditHoverIcon from 'assets/icon/icon-icon-options-edit_hover.svg';
import HoverImage from 'react-hover-image/build';
import { Button, Card, CardBody, Col, Container, FormGroup, Input, InputGroup, InputGroupText, Label, Row } from 'reactstrap';
import { dateFormate, currencyFormat, cellRendererCheck } from 'utils/columns';
import { Field, Formik } from 'formik';
import PatientTypeTable from './PatientTable/index';
import FormikDatePicker from 'components/common/Fields/FormikDatePicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import FormikInputField from 'components/common/Fields/FormikInputField';
import FormikSelectField from 'components/common/Fields/FormikSelectField';
import useAxios from 'hooks/useAxios';
import { toast } from 'react-toastify';
import useContextService from 'hooks/useContextService';
import { cloneDeep } from 'lodash';
import { ModuleAccess } from 'utils/moduleaccess';
import save from "assets/icon/save.svg";
import reseticon from "assets/icon/reset.svg";
import Drawer from "components/Drawer";
import AddPatient from './AddPatient';
import { orderBy } from 'lodash';
let hasDatePopupOpen = false;
let addPatientData = {};

const PatientType = (props) => {
    const {
        orgId,
        key,
    } = props;
    const API = useAxios();
    const patientStatusdata = [
        { id: "Y", label: "IN" },
        { id: "N", label: "OUT" },
    ]
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showDetails, setShowDetails] = useState(true);
    const [collapseSider, setcollapseSider] = useState(false);
    const [collIcon, setCollIcon] = useState(faAngleUp);
    const [patientcodeerr, setPatientCodeError] = useState('');
    const [patientdescerr, setPatientDescError] = useState('');
    const [patientstatuserr, setPatientStatusError] = useState("");
    const [dateerror, setDateError] = useState("");
    const [patientcode, setPatientCode] = useState('');
    const [patientdesc, setPatientDesc] = useState("");
    const [active, setActive] = useState(true);
    const [totalRecords, SetTotalRecords] = useState("");
    const [errorMessage, setErrorMessage] = useState('');

    const [openPharmacy, setOpenPharmacy] = useState(false);

    const manvalPharmacy = () => {
        setOpenPharmacy(!openPharmacy); 
    }

    const {
        states: { configPatientType },
        setStates,
         resetStates,
    } = useContextService();
    const { search, } = configPatientType;

    const initialStates = {
        currentPage: 1,
        pageSize: 10,
        order: 'desc',
        orderBy: 'modifiedDate',
        filters: [],
    }

    useEffect(()=>{
        setOpenPharmacy(false)
    },[orgId])
    const [selectedPatientStatus, setSelectedPatientStatus] = useState({})

    const [effectiveDate, setEffectiveDate] = useState(null)
    const toggleSider = () => {
        setcollapseSider(!collapseSider);
        if (!collapseSider) {
            setCollIcon(faAngleDown);
        }
        else {
            setCollIcon(faAngleUp);
        }
    }

    const handleMouseLeave = () => {
        hasDatePopupOpen = false;
    };

    const hasPermission = (code) => {
        return ModuleAccess("CON", code);
      };
    

    const handleDateClick = (id) => {

        if (hasDatePopupOpen) {
            hasDatePopupOpen = false;
            return;
        }
        const calendarButton = document.getElementById(id);
        if (calendarButton) {
            calendarButton.click();
            hasDatePopupOpen = true;
        }
    };

    // const handelAdd = () => {
    //     setShowDetails(false)
    // }
    // useEffect(() => {
    // }, [showDetails])

    const initialValues = {
        patienttypecode: '',
        Patientdesc: '',
        patientstatus: {},
        effectivedate: '',
    };
    const handelpatientcode = ({ target: { value } }) => {
        setPatientCode(value)
        if (value.length > 0) {
            setPatientCodeError("")
        }
        if (value.length == 0) {
            setPatientCodeError("Enter the Patient Type Code")
        }
        addPatientData.patientcode = value
    }
    const handelPatientdesc = ({ target: { value } }) => {
        setPatientDesc(value)
        if (value.length > 0) {
            setPatientDescError("")
        }
        addPatientData.patientdesc = value
    }
    const handelpatientStatus = (e, setFieldValue,) => {
        const { value } = e.target;
        setFieldValue('patientstatus', value);
        if (value.length > 0) {
            setPatientStatusError("")
        }
        setSelectedPatientStatus(value)
        addPatientData.patientstatus = value
    }
    const handleStartDate = (startDate) => {
        let stDate = dateFormate(startDate);
        if (startDate.length > 0) {
            setDateError("")
        }
        setEffectiveDate(stDate);
        addPatientData.effectiveDate = stDate;
    };
    const handelActive = (event) => {
        setActive(event.target.checked)
    }
    const handleSubmit = async () => {
        let checkedvalue = ""
        if (patientcode.length == 0) {
            setPatientCodeError("Enter the Patient Type Code")
        }
        if (patientdesc.length == 0) {
            setPatientDescError("Enter the Patient Type Description")
        }
        if (selectedPatientStatus.length == 0) {
            setPatientStatusError("Select Patient Status")
        }
        let panel = find(patientStatusdata, {
            id: selectedPatientStatus,
        });
        if (selectedPatientStatus.length > 0) {
            setPatientStatusError("")
        }
        if (active == true) {
            checkedvalue = "N"
        }
        if (active == false) {
            checkedvalue = "Y"
        }
        let AddPatientEntity = []
        let payload = {};
        payload.PatientTypeCode = patientcode,
            payload.PatientTypeDescription = patientdesc,
            payload.PatientStatus = selectedPatientStatus
        payload.InactiveFlag = checkedvalue
        AddPatientEntity.push(payload)
        if (patientcode.length > 0 && patientdesc.length > 0 && selectedPatientStatus) {
            try {
                const { data } = await API.post(`SBTenant/${orgId.tenantID}/Configuration/AddPatient`, { AddPatientEntity }, { hasDefaultURL: true });
                
                if (data) {
                    if (data[0].success === false) {
                     
                      setErrorMessage("Patient type already exists");
                    }
                    else {
                        toast.success('Patient Added Successfully');
                        fetchAccumulatorTable();
                        handelCancel()
                    }
                }
            } catch (error) {
                console.log(error);
                setLoading(false);
            }
        }

    }
    const fetchAccumulatorTable = async (filterObj) => {
        debugger;
        if(search.isFilterCancel) {
         search.isFilterCancel = false;
         filterObj = cloneDeep(search);
        }     

        if (filterObj != undefined) {
            initialStates.filters = filterObj.filters
            initialStates.order = filterObj.order ? filterObj.order : initialStates.order
            initialStates.orderBy = filterObj.orderBy ? filterObj.orderBy : initialStates.orderBy
            initialStates.pageSize = filterObj.pageSize ? filterObj.pageSize : initialStates.pageSize
            initialStates.currentPage = filterObj.currentPage ? filterObj.currentPage : initialStates.currentPage
        }
        setLoading(true)
        try {
            const { data } = await API.post(`SBTenant/${orgId.tenantID}/Configuration/patientlist`, initialStates, {
                hasDefaultURL: true,
            })

            if (data?.items?.length > 0) {
                const transformedData = data.items.map(item => {
                    return { ...item, isInPatient: item.isInPatient === 'Y' ? 'IN' : item.isInPatient === 'N' ? 'OUT' : '-'};
                });
                setData(transformedData);
                SetTotalRecords(data.totalRecords);              
            }
            else{
                setData([]);
                SetTotalRecords(0);  
            }
            setLoading(false);
        } catch (error) {
            setLoading(false)
        }

    }

    useEffect(() => {
         resetStates('configPatientType')
        handelCancel()
    }, [orgId])
    const handelCancel = () => {
        setErrorMessage("");
        setPatientCode('');
        setPatientDesc("");
        setSelectedPatientStatus("");
        setPatientCodeError("");
        setPatientDescError("");
        setPatientStatusError("");
    }

    useEffect(() => {
        fetchAccumulatorTable()
    }, [orgId, key])

    const handleSearchColumnFilters = async (columnFilters) => {
        debugger;
        const filterObj = cloneDeep(search);
        if (columnFilters && columnFilters.length > 0) {
            filterObj.filters = [...filterObj.filters, ...columnFilters];
        }
        configPatientType.search.currentPage=1;
        filterObj.currentPage=1;
        await fetchAccumulatorTable(filterObj);
    };

    const handlePageChange = (filter, haveColFilter) => {
        debugger
        onPageChange(filter,haveColFilter);
    };

    const onPageChange = (filter, haveColFilter) => {
        debugger
        updatePatientSearch(filter);
        const filterObj = cloneDeep(search);
        if (haveColFilter) {
            filterObj.filters = [...filterObj.filters, ...filter.filters];
            fetchAccumulatorTable(filterObj);
        } else {
            // filterObj.filters = [...filterObj.filters, ...filter.filters];
            fetchAccumulatorTable(filterObj);
        }
    };

     const updatePatientSearch = (filter) => {
     configPatientType.search.currentPage = filter.currentPage;
     configPatientType.search.pageSize= filter.pageSize;
     configPatientType.search.order = filter.order;
     configPatientType.search.orderBy = filter.orderBy
    }

    return (
        <div>
            <Container fluid className="width_info">
            {/* <div className={collapseSider ? "mb-0" : "mb-3"}>

                <Card hidden={collapseSider} className="border-0 shadow-top ">
                    <CardBody>
                   
            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                enableReinitialize={true}
                // enableReinitialize={true}
                children={(props) => {
                    const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched } = props;
                    return (
                        <div hidden={collapseSider}>
                            <h5 className='f-16 text-primary font-weight-700'>
                                Add Patient Type
                            </h5>
                            <div >
                                <Row sm={5} className='d-flex' style={{}}>

                                    <Col md={3} lg={3} sm={6} xs={6}  >
                                        {' '}
                                        <FormGroup>
                                            <Label for='patienttypecode'>Patient Type Code</Label>
                                            <Input
                                                id='patienttypecode'
                                                name='patienttypecode'
                                                type='text'
                                                value={patientcode}
                                                className="required"
                                                placeholder="Enter Patient Type Code"
                                                autoComplete='off'
                                                onChange={handelpatientcode}
                                                component={FormikInputField}
                                            // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                                            />

                                            {patientcodeerr && <div className="text-danger font-size-12">{patientcodeerr}</div>}
                                        </FormGroup>
                                    </Col>

                                    <Col md={3} lg={3} sm={6} xs={6}  >
                                        {' '}
                                        <FormGroup>
                                            <Label for='Patientdesc'>Patient Type Description</Label>
                                            <Input
                                                id='Patientdesc'
                                                name='Patientdesc'
                                                type='text'
                                                value={patientdesc}
                                                className="required"
                                                placeholder="Enter Patient Type Description"
                                                autoComplete='off'
                                                component={FormikInputField}
                                                onChange={handelPatientdesc}
                                            // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                                            />
                                            {patientdescerr && <div className="text-danger font-size-12">{patientdescerr}</div>}
                                        </FormGroup>
                                    </Col>
                                    <Col md={3} lg={3} sm={6} xs={6}  >
                                        {' '}
                                        <FormGroup>
                                            <Label for='Patientstatus'>Patient Status</Label>
                                            <Field
                                                // id='patientstatus'
                                                name='patientstatus'
                                                type='text'
                                                placeholder="Enter Patient Type Description"
                                                autoComplete='off'
                                                defaultoption='--Select--'
                                                className="required"
                                                options={patientStatusdata}
                                                value={selectedPatientStatus}
                                                component={FormikSelectField}
                                                onChange={(e) => handelpatientStatus(e, setFieldValue)}
                                                keys={{
                                                    id: 'id',
                                                    label: 'label',
                                                }}
                                            />
                                            {patientstatuserr && <div className="text-danger font-size-12">{patientstatuserr}</div>}
                                        </FormGroup>
                                    </Col>
                                    <Col md={3} lg={3} sm={6} xs={6} style={{ marginTop: "32px" }}  >
                                        {' '}
                                        <FormGroup>
                                            <Label for='effectivedate'>Active
                                            </Label>
                                            <Input
                                                type="checkbox"
                                                style={{ marginLeft: "10px" }}
                                                id="active"
                                                name="active"
                                                checked={active}
                                                onChange={(event) => {
                                                    handelActive(event)
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </div>
                            <div hidden={""}>
                                <Row style={{ justifyContent: "flex-end" }}>
                                    <Col sm={8}>
                                        {errorMessage ? (
                                            <div
                                                style={{
                                                    display: "inline-block",
                                                    backgroundColor: "#ffe6e6",
                                                    marginLeft: "10px",
                                                    //padding: "5px"
                                                }}
                                                className="text-danger f-12"
                                            >
                                                {errorMessage}
                                            </div>
                                        ) : null}
                                    </Col>
                                    <Col sm={2} className="d-flex"
                                        style={{ justifyContent: "flex-end" }}
                                    >
                                        <Label>{""}</Label>
                                        <Button
                                            // hidden={isAddPermission}
                                            // disabled={isSubmitting}
                                            color="primary"
                                            className="search"
                                            onClick={handleSubmit}
                                        // disabled={!coveredEntityid}
                                         hidden={!hasPermission("ED")}
                                        >
                                             <span className="right_5">
                    <img src={save} alt="" />
                  </span> Save
                                        </Button>
                                        <Button

                                            color="primary"
                                            className="reset"
                                            onClick={handelCancel}
                                        >
                                           <span className="right_5">
                                                               <img src={reseticon} alt="" />
                                                             </span> Reset
                                        </Button>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={8}>
                                        {errorMessage ? (
                                            <div
                                                style={{
                                                    display: "inline-block",
                                                    backgroundColor: "#ffe6e6",
                                                   // marginLeft: "10px",
                                                    //padding: "5px"
                                                }}
                                                className="text-danger f-12"
                                            >
                                                {errorMessage}
                                            </div>
                                        ) : null}
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    );
                }}></Formik>
                    </CardBody>
                </Card>
                </div> */}
                <Card className="border-0 shadow-top">
                    <CardBody>
               <PatientTypeTable
                orgId={orgId}
                data={data}
                totalSize={totalRecords}
                filters={search}
                fetchAccumulatorTable={fetchAccumulatorTable}
                toggleSider={toggleSider}
                manvalPharmacy={manvalPharmacy}
                collapseSider={collapseSider}
                onPageChange={onPageChange}
                handleSort={handlePageChange}
                onSearchColumnFilters={handleSearchColumnFilters}
            />
                    </CardBody>
                </Card>
            </Container>
          
            <Drawer
        direction="end"
        isOpen={openPharmacy}
        toggle={manvalPharmacy}
        size="lg"
        title="Add Patients"
      >
        <AddPatient  orgId={orgId}         manvalPharmacy={manvalPharmacy}      fetchAccumulatorTable={fetchAccumulatorTable}
        />
      </Drawer>
           

        </div>
    )
}

export default PatientType
